import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Printer = createSvgIcon(
  <path d="M6 0h8.341L18 3.659V6h4.5v15h-5.25v3H6.75v-3H1.5V6H6V0Zm2.25 6h7.5V4.591L13.409 2.25H8.25V6ZM9 21.75h6v-6H9v6Zm8.25-3h3V8.25H3.75v10.5h3V13.5h10.5v5.25Z" />,
  'Printer'
);

export { Printer };